import React, { useEffect, useState } from "react";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import "./app.css";
import Loading from "./loading.js";
import { secretKey } from "./data";

const MySwal = withReactContent(Swal2);

const AddLead = (props) => {
  const [loading, setLoading] = useState(true);
  const [leadName, setLeadName] = useState("");
  const [leadMail, setLeadMail] = useState("");
  const [leadPhone, setLeadPhone] = useState("");
  const [leadSource, setLeadSource] = useState("");
  const [idSource, setIdSource] = useState("");
  const [leadNote, setLeadNote] = useState("");
  const [sourceLink, setSourceLink] = useState("");
  const [leadCompany, setLeadCompany] = useState("");
  const [sources, setSources] = useState([]);

  const fetchLeadSources = async () => {
    var body = {};

    await fetch("https://apisellcrm.ftpeople.pl/getLeadSources", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setSources(data.filter((el) => el.name !== "Polecenie"));
        setLoading(false);
      })
      .catch((error) => {});
  };

  const fetchAddLead = async () => {
    var body = {
      name: leadName,
      phone: leadPhone,
      mail: leadMail,
      source: leadSource,
      note: leadNote,
      company: leadCompany.trim(),
      idSource: idSource.trim(),
      linkSource: sourceLink.trim(),
      auto: "0",
    };

    await fetch("https://apisellcrm.ftpeople.pl/addLead", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.text())
      .then((data) => {
        MySwal.fire({
          icon: "success",
          title: "Dodano",
          text: "lead",
        }).then(async (result) => {
          props.close();
        });
      })
      .catch((error) => {});
  };

  const getData = () => {
    fetchLeadSources();
  };

  useEffect(() => {
    setLoading(true);
    getData();
  }, []);

  const validate = () => {
    if (
      leadName.length === 0 ||
      leadPhone.length === 0 ||
      leadMail.length === 0 ||
      leadSource.length === 0 ||
      leadCompany.length === 0
    ) {
      return false;
    } else {
      return true;
    }
  };

  const addLead = () => {
    if (validate()) {
      fetchAddLead();
    } else {
      MySwal.fire({
        icon: "error",
        title: "Wypełnij",
        text: "wymagane pola formularza",
      }).then(async (result) => {});
    }
  };

  return (
    <>
      <div
        style={{
          width: "50vw",
          borderRadius: "15px",
          boxShadow: "-8px 0px 24px 0px rgba(66, 68, 90, 1)",
          position: "fixed",
          right: "0",
          top: "10vh",
          backgroundColor: "white",
          padding: "2%",
          margin: "0px 10px",
        }}
      >
        {loading ? (
          <Loading />
        ) : (
          <>
            <div style={{ display: "flex", marginBottom: "3vh" }}>
              <div
                style={{
                  width: "85%",
                  textAlign: "left",
                  fontWeight: "600",
                  fontSize: "2vw",
                }}
              >
                DODAJ LEAD
              </div>
              <div style={{ width: "15%" }}>
                <button
                  className="loginButtonLogin"
                  value="yes"
                  style={{
                    margin: "0",
                    backgroundColor: "navy",
                    borderColor: "navy",
                    width: "100%",
                  }}
                  onClick={props.close}
                >
                  X
                </button>
              </div>
            </div>
            <div style={{ display: "flex", gap: "50px" }}>
              <div style={{ width: "45%", textAlign: "left" }}>
                <p
                  style={{
                    margin: "0",
                    marginBottom: "10px",
                    fontWeight: "600",
                    fontSize: ".8vw",
                    paddingLeft: "20px",
                  }}
                >
                  imię i nazwisko <span style={{ color: "red" }}>*</span>
                </p>
                <input
                  type="text"
                  style={{
                    width: "100%",
                    padding: "0px 10px",
                    boxSizing: "border-box",
                  }}
                  value={leadName}
                  onChange={(e) => setLeadName(e.target.value)}
                />
              </div>
              <div style={{ width: "45%", textAlign: "left" }}>
                <p
                  style={{
                    margin: "0",
                    marginBottom: "10px",
                    fontWeight: "600",
                    fontSize: ".8vw",
                    paddingLeft: "20px",
                  }}
                >
                  adres e-mail <span style={{ color: "red" }}>*</span>
                </p>
                <input
                  type="text"
                  style={{
                    width: "100%",
                    padding: "0px 10px",
                    boxSizing: "border-box",
                  }}
                  value={leadMail}
                  onChange={(e) => setLeadMail(e.target.value)}
                />
              </div>
            </div>
            <div style={{ display: "flex", gap: "50px", marginTop: "20px" }}>
              <div style={{ width: "45%", textAlign: "left" }}>
                <p
                  style={{
                    margin: "0",
                    marginBottom: "10px",
                    fontWeight: "600",
                    fontSize: ".8vw",
                    paddingLeft: "20px",
                  }}
                >
                  numer telefonu <span style={{ color: "red" }}>*</span>
                </p>
                <input
                  type="text"
                  style={{
                    width: "100%",
                    padding: "0px 10px",
                    boxSizing: "border-box",
                  }}
                  value={leadPhone}
                  onChange={(e) => setLeadPhone(e.target.value)}
                />
              </div>
              <div style={{ width: "45%", textAlign: "left" }}>
                <p
                  style={{
                    margin: "0",
                    marginBottom: "10px",
                    fontWeight: "600",
                    fontSize: ".8vw",
                    paddingLeft: "20px",
                  }}
                >
                  źródło <span style={{ color: "red" }}>*</span>
                </p>
                <select
                  type="text"
                  style={{
                    width: "100%",
                    padding: "0px 10px",
                    boxSizing: "border-box",
                  }}
                  value={leadSource}
                  onChange={(e) => setLeadSource(e.target.value)}
                >
                  {leadSource === "" ? <option>Wybierz....</option> : ""}
                  {sources.map((el) => (
                    <option key={el.name} value={el.name}>
                      {el.name}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div style={{ display: "flex", gap: "50px", marginTop: "20px" }}>
              <div style={{ width: "45%", textAlign: "left" }}>
                <p
                  style={{
                    margin: "0",
                    marginBottom: "10px",
                    fontWeight: "600",
                    fontSize: ".8vw",
                    paddingLeft: "20px",
                  }}
                >
                  dział <span style={{ color: "red" }}>*</span>
                </p>
                <select
                  type="text"
                  style={{
                    width: "100%",
                    padding: "0px 10px",
                    boxSizing: "border-box",
                  }}
                  value={leadCompany}
                  onChange={(e) => setLeadCompany(e.target.value)}
                >
                  {leadCompany === "" ? <option>Wybierz....</option> : ""}
                  {props.companies.map((el) => (
                    <option key={el.name} value={el.name}>
                      {el.name}
                    </option>
                  ))}
                </select>
              </div>
              <div style={{ width: "45%", textAlign: "left" }}>
                <p
                  style={{
                    margin: "0",
                    marginBottom: "10px",
                    fontWeight: "600",
                    fontSize: ".8vw",
                    paddingLeft: "20px",
                  }}
                >
                  ID źródło
                </p>
                <input
                  type="text"
                  style={{
                    width: "100%",
                    padding: "0px 10px",
                    boxSizing: "border-box",
                  }}
                  value={idSource}
                  onChange={(e) => setIdSource(e.target.value)}
                />
              </div>
            </div>
            <div style={{ display: "flex", gap: "50px", marginTop: "20px" }}>
              <div style={{ width: "45%", textAlign: "left" }}>
                <p
                  style={{
                    margin: "0",
                    marginBottom: "10px",
                    fontWeight: "600",
                    fontSize: ".8vw",
                    paddingLeft: "20px",
                  }}
                >
                  link - źródło<span style={{ color: "red" }}>*</span>
                </p>
                <input
                  type="text"
                  style={{
                    width: "100%",
                    padding: "0px 10px",
                    boxSizing: "border-box",
                  }}
                  value={sourceLink}
                  onChange={(e) => setSourceLink(e.target.value)}
                />
              </div>
              <div style={{ width: "45%", textAlign: "left" }}></div>
            </div>
            <div style={{ display: "flex", gap: "50px", marginTop: "20px" }}>
              <div style={{ width: "99%", textAlign: "left" }}>
                <p
                  style={{
                    margin: "0",
                    marginBottom: "10px",
                    fontWeight: "600",
                    fontSize: ".8vw",
                    paddingLeft: "20px",
                  }}
                >
                  uwagi - źródło
                </p>
                <textarea
                  type="text"
                  style={{
                    width: "100%",
                    padding: "10px 10px",
                    boxSizing: "border-box",
                    height: "10vh",
                    resize: "none",
                  }}
                  value={leadNote}
                  onChange={(e) => setLeadNote(e.target.value)}
                />
              </div>
            </div>
            <div style={{ marginTop: "50px", textAlign: "left" }}>
              <button
                className="loginButtonLogin"
                value="yes"
                style={{
                  margin: "0",
                  backgroundColor: "navy",
                  borderColor: "navy",
                }}
                onClick={addLead}
              >
                DODAJ LEAD
              </button>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default AddLead;
